import * as React from 'react';
import refIsCallback from './refIsCallback.js';
import refIsObject from './refIsObject.js';

function useForwardedRef(forwardedRef) {
  var ref = React.useRef(null);
  React.useEffect(function () {
    if (refIsCallback(forwardedRef)) {
      forwardedRef(ref.current);
    }
  });
  return refIsObject(forwardedRef) ? forwardedRef : ref;
}

export { useForwardedRef as default };
//# sourceMappingURL=useForwardedRef.js.map
